import React, { Component } from 'react';
import Gallery from 'react-photo-gallery';
// import $ from 'jquery';
// import { findDOMNode } from 'react-dom';

import {
  flickrAPIkey,
  photoSetID,
  userID,
} from '../../config';
import {
  t,
} from '../../helpers';

import './Photography.css';

class Photography extends Component {
  constructor(props) {
    super(props);
    this.flickrOptions = {
      ratio: 1200 / 1600,
      height: 1200,
      width: 1600,
    };
    this.state = {
      // windowHeight: window.innerHeight,
      // windowWidth: window.innerWidth,
      pictures: [],
    };
  }

  async componentWillMount() {
    try {
      const call = await fetch(`https://api.flickr.com/services/rest/?method=flickr.photosets.getPhotos&api_key=${flickrAPIkey}&photoset_id=${photoSetID}&user_id=${userID}&format=json&nojsoncallback=1&extras=url_l`);
      const album = await call.json();
      const pictures = album.photoset.photo
        .filter((picture, index) => index < 9)
        .map(picture => ({
          src: picture.url_l,
          width: parseInt(picture.width_l, 10),
          height: parseInt(picture.height_l, 10),
        }));
      this.setState({
        pictures,
      });
    } catch (e) {
      console.error(e);
    }
    /* let timeout;
    const delay = 300;
    // window.resize event listener
    window.addEventListener('resize', () => {
      // clear the timeout
      clearTimeout(timeout);
      // start timing for event "completion"
      timeout = setTimeout(this.getDimensions, delay);
    }); */
  }

  render() {
    /* const fWidth = this.flickrOptions.width > this.state.windowWidth ?
      this.state.windowWidth : this.flickrOptions.width;

    const fHeight = fWidth * this.flickrOptions.ratio; */
    const { pictures } = this.state;
    return (
      <section id="photography" className="content-section text-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <h2>{t('photography.title')}</h2>
              <p>{t('photography.text')}{' '}
                <a
                  href="https://www.flickr.com/photos/134604478@N02/albums/with/72157682928162795"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('photography.link')}.
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="flickr-container row">
            {!!pictures.length && <Gallery photos={pictures} />}
            { /*
              <a
                data-flickr-embed="true"
                href="https://www.flickr.com/photos/134604478@N02/albums/72157682928162795"
                title="Black&amp;White&amp;Grey"
                style={{ height: fHeight, width: fWidth }}
              >
                <img
                  src="https://farm3.staticflickr.com/2888/34073162771_66d975f144_h.jpg"
                  width={fWidth}
                  height={fHeight}
                  alt="Black&amp;White&amp;Grey"
                />
              </a>
            */ }
          </div>
          { /* <div id="flickrembed" /> */ }
        </div>
      </section>
    );
  }
}

export default Photography;



// WEBPACK FOOTER //
// ./src/components/Photography/index.js